module.exports = __webpack_public_path__ + "img/registration_closed.25312a57.jpeg";